<template>
  <div class="attendee-header-mobile mobile-only">
    <div id="header-text"></div>

    <div class="attendee-header-mobile__right">
      <button @click="openFilterMobile" v-if="attendee.enable_session_filtering && eventListPage">
        <div class="attendee-header-mobile__notify" v-if="filtersUsed">
          {{ filtersUsed }}
        </div>
        <i class="fa-solid fa-sliders"></i>
      </button>
      <DropDownMenu position="right">
        <div class="attendee-header-mobile__icon">
          <img
            v-if="attendee.profile_image_url"
            :src="attendee.profile_image_url"
            alt="User Photo"
            width="36"
          />

          <div v-else class="avatar-no-photo">
            <i class="fa-regular fa-user"></i>
          </div>
        </div>
      </DropDownMenu>
    </div>


  </div>
</template>


<style lang="scss">
.attendee-header-mobile{
  border-bottom: 1px solid var(--attendee-border-color);
  background-color: white;
  position: fixed;
  width: 100%;
  z-index: 99;
  top: 0;
  padding: 0 var(--attendee-gap-md);
  height: var(--attendee-header-mobile-height);
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  align-items: center;

  &__notify {
    background-color: rgb(255, 102, 102);
    font-size: 12px;
    color: white;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -10px;
    right: -10px;
    position: absolute;
    z-index: 2;
    min-width: 15px;
    border-radius: 15px;
    padding: 0 4px;
  }

  &__right{
    display: flex;
    align-items: center;
    gap: var(--attendee-gap-md);

    button{
      position: relative;
      background: none;
      border: none;
      cursor: pointer;
      font-size: 18px;

      svg{
        color: var(--attendee-text-primary-color);
      }
    }

  }

  &__icon{
    //padding-right: var(--attendee-gap-md);

    img{
      border-radius: 50%;
      min-width: 36px;
      height: 36px;
      width: 36px;
      object-fit: cover;
    }

    svg{
      color: white;
      font-size: 18px;
    }
  }

  .avatar-no-photo{
    background-color: rgb(229, 226, 226);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }



  #header-text{
    font-size: 21px;
    color: var(--attendee-text-primary-color);
    font-weight: 600;
  }

}
</style>

<script>
import DropDownMenu from "../DropDownMenu";
import {mapGetters} from "vuex";
import {ROUTES} from "../../../router";

export default {
  components:{
    DropDownMenu,
  },
  computed: {
    ...mapGetters('attendeeStore', [
      'attendee',
    ]),
    ...mapGetters('agendaStore', [
      'filtersUsed',
    ]),
    eventListPage(){
      return ROUTES.AGENDA_EVENT.replace(':attendeeId', this.$route.params.attendeeId) === this.$route.path;
    }
  },
  mounted() {
    // console.log(this.$route.params.attendeeId);
  },
  methods:{
    openFilterMobile() {
      this.$store.dispatch("agendaStore/openFilterMobile");
    },

    closeFilterMobile() {
      this.$store.dispatch("agendaStore/closeFilterMobile");
    },
  }
}

</script>